export const INITIAL_STATE = {
    name: "",
    email: "",
    phone: "",
    country_code: "+91",
    country_name: "India",
    comment: "",
    looking_for: "",
};